import axios from "axios";
import jsonpAdapter from 'axios-jsonp';
import Request from "./apiRequestParametersGenerator";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";

const api = axios.create({
    baseURL: ConfigurationHelper.getGlobalConfiguration().apiUrl,
    adapter: jsonpAdapter
});

class Api {
    runNewApi(url, page, searchTerm) {
        const request = new Request(true)
            .withPageV3(page)
            .withNumberOfItemsV3(12)
            .withQuery(searchTerm)
            .getParameters();

        return axios.get(
            url,
            {
                params: request
            }
        );
    }
    runApi(url, request) {
        return api.get(
            url, {
                params: request
            }
        );
    }

    inTimeProducts(url) {
        return this.runApi(url, new Request().getParameters());
    }

    products(url) {
        return axios.get(url);
    }

    recommendedProducts(url, channelIdForRecommended) {
        return this.runApi(url,
            new Request().withChannel(channelIdForRecommended).getParameters()
        );
    }

    channelService(url) {
        return axios.get(
            url, {
                params: {}
            }
        );
    }
    suggestKeywords(url,query) {
        return this.runApi(url, new Request().withQuery(query));
    }
    ambassador(user_id) {
        const url = ConfigurationHelper.getGlobalConfiguration().apiUrl + "accountUser/ambassador/" + user_id;
        return this.runApi(url,  new Request().getParameters());
    }
    getLiveEvent(userId){
        const url =  ConfigurationHelper.getGlobalConfiguration().apiUrl + `liveShopping/${userId}`;
        return this.runApi(url, new Request().getParameters())
    }
    content(url, page, query, number, user_id) {
        return this.runApi(url, new Request()
            .withPage(page)
            .withNumberOfItems(number || 24)
            .withQuery(query)
            .withStatus("approved")
            .withOwnerId(user_id)
            .getParameters()
        );
    }

}

export default new Api();